/**
 * Single source of truth for the Seller Agreement.
 *
 * Bump SELLER_AGREEMENT_VERSION whenever the agreement text changes
 * (e.g. when the lawyer-reviewed text replaces the placeholder). Every seller
 * whose recorded acceptance version differs will be asked to re-accept the
 * agreement the next time they open their dashboard.
 */
export const SELLER_AGREEMENT_VERSION = "2026-08-placeholder";

export const SELLER_AGREEMENT_SECTION_KEYS = [
  "commission",
  "payouts",
  "shipping",
  "returns",
  "quality",
  "taxes",
  "suspension",
  "complaints",
  "governingLaw",
] as const;

export type SellerAgreementSectionKey =
  (typeof SELLER_AGREEMENT_SECTION_KEYS)[number];

export const hasAcceptedCurrentAgreement = (
  acceptedAt?: string | null,
  version?: string | null
) => !!acceptedAt && version === SELLER_AGREEMENT_VERSION;
